// Model columns in the order they should appear
const modelColumns = [
  { id: 'asi1_mini', name: 'ASI-1 Mini Latest' },
  { id: 'gemini', name: 'Gemini 2.0 Flash' },
  { id: 'deepseek', name: 'DeepSeek V3' },
  { id: 'gpt4o_nov24', name: 'GPT 4o (Nov-24)' },
  { id: 'asi1_mini_0225', name: 'ASI-1 Mini 02-25' },
  { id: 'llama31', name: 'LLAMA 3.1 405B' },
  { id: 'o1', name: 'O1 Mini' },
  { id: 'llama33', name: 'LLAMA 3.3 70B' },
  { id: 'gpt4o_mini', name: 'GPT 4o Mini' },
];

export default modelColumns;
